import axiosInstance, { axiosFileUpload } from "./axios.instance";
import { IFileInfo, IShapeFile } from "../_types_";

export const uploadFile = async (files: FileList) => {
  var formData = new FormData();
  formData.append("files", files[0]);
  const file: IFileInfo[] = await axiosFileUpload.post("File", formData);
  return file[0];
};

export const uploadMultiFile = async (
  files: FileList,
  isTimDuong = false
): Promise<IShapeFile | undefined> => {
  var formData = new FormData();
  for (let i = 0; i < files.length; i++) {
    const file = files[i];
    formData.append("files", file);
  }
  if (!isTimDuong) {
    const file: IShapeFile = await axiosFileUpload.post(
      `File/shapetogeometry`,
      formData
    );
    return file;
  }
  return await axiosFileUpload.post(`File/shapefile`, formData);
};

export const downloadFileAsync = async (
  fileId: string | number,
  fileName: string
) => {
  axiosInstance
    .get(`File?id=${fileId}&typeId=1`, {
      responseType: "blob",
    })
    .then((rp) => {
      const blob = new Blob([rp as any]);
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", fileName);
      document.body.appendChild(link);
      link.click();
    })
    .catch((er) => console.log({ er }));
};
